import { Node, mergeAttributes } from '@tiptap/core';

// Inline SVG marks, keyed by note type. Replaces the free-text `icon` attribute,
// which had 142 blocks hardcoding a lightbulb and the rest a book. The attribute
// is still parsed for backwards compatibility but no longer rendered.
const NOTE_ICONS = {
  'key-idea':
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 22h4"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1.38.5 2.65 1.5 3.5.76.76 1.23 1.52 1.41 2.5"/></svg>',
  safeguard:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M12 8v4M12 16h.01"/></svg>',
  pastoral:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>',
  warning:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><path d="M12 9v4M12 17h.01"/></svg>',
  tip: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 22h4"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1.38.5 2.65 1.5 3.5.76.76 1.23 1.52 1.41 2.5"/></svg>',
  disclaimer:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8"/></svg>',
  note: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>',
};
const noteIcon = (t) => NOTE_ICONS[t] || NOTE_ICONS.note;

// Compass rose watermark for pastoral notes. Sized to the block's SHORT axis
// and masked off the text column by CSS, so the drawing is authored plainly
// here and the layout decides how to reveal it.
const PASTORAL_WATERMARK =
  '<svg viewBox="0 0 200 200" aria-hidden="true"><defs><radialGradient id="nbRoseFade" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#fff" stop-opacity="1"/><stop offset="55%" stop-color="#fff" stop-opacity="0.92"/><stop offset="100%" stop-color="#fff" stop-opacity="0"/></radialGradient><mask id="nbRoseMask"><rect width="200" height="200" fill="url(#nbRoseFade)"/></mask></defs><g mask="url(#nbRoseMask)"><circle cx="100" cy="100" r="95" fill="none" stroke="#2B6B5F" stroke-width="2.5"/><circle cx="100" cy="100" r="88" fill="none" stroke="#2B6B5F" stroke-width="1"/><circle cx="100" cy="100" r="62" fill="none" stroke="#2B6B5F" stroke-width="1"/><path d="M100.0 12.0 L100.0 22.0 M109.2 12.5 L108.7 17.5 M118.3 13.9 L117.3 18.8 M127.2 16.3 L125.6 21.1 M135.8 19.6 L133.8 24.2 M144.0 23.8 L139.0 32.5 M151.7 28.8 L148.8 32.9 M158.9 34.6 L155.5 38.3 M165.4 41.1 L161.7 44.5 M171.2 48.3 L167.1 51.2 M176.2 56.0 L167.5 61.0 M180.4 64.2 L175.8 66.2 M183.7 72.8 L178.9 74.4 M186.1 81.7 L181.2 82.7 M187.5 90.8 L182.5 91.3 M188.0 100.0 L178.0 100.0 M187.5 109.2 L182.5 108.7 M186.1 118.3 L181.2 117.3 M183.7 127.2 L178.9 125.6 M180.4 135.8 L175.8 133.8 M176.2 144.0 L167.5 139.0 M171.2 151.7 L167.1 148.8 M165.4 158.9 L161.7 155.5 M158.9 165.4 L155.5 161.7 M151.7 171.2 L148.8 167.1 M144.0 176.2 L139.0 167.5 M135.8 180.4 L133.8 175.8 M127.2 183.7 L125.6 178.9 M118.3 186.1 L117.3 181.2 M109.2 187.5 L108.7 182.5 M100.0 188.0 L100.0 178.0 M90.8 187.5 L91.3 182.5 M81.7 186.1 L82.7 181.2 M72.8 183.7 L74.4 178.9 M64.2 180.4 L66.2 175.8 M56.0 176.2 L61.0 167.5 M48.3 171.2 L51.2 167.1 M41.1 165.4 L44.5 161.7 M34.6 158.9 L38.3 155.5 M28.8 151.7 L32.9 148.8 M23.8 144.0 L32.5 139.0 M19.6 135.8 L24.2 133.8 M16.3 127.2 L21.1 125.6 M13.9 118.3 L18.8 117.3 M12.5 109.2 L17.5 108.7 M12.0 100.0 L22.0 100.0 M12.5 90.8 L17.5 91.3 M13.9 81.7 L18.8 82.7 M16.3 72.8 L21.1 74.4 M19.6 64.2 L24.2 66.2 M23.8 56.0 L32.5 61.0 M28.8 48.3 L32.9 51.2 M34.6 41.1 L38.3 44.5 M41.1 34.6 L44.5 38.3 M48.3 28.8 L51.2 32.9 M56.0 23.8 L61.0 32.5 M64.2 19.6 L66.2 24.2 M72.8 16.3 L74.4 21.1 M81.7 13.9 L82.7 18.8 M90.8 12.5 L91.3 17.5" stroke="#2B6B5F" stroke-width="1.4" fill="none" stroke-linecap="round"/><path d="M141.0 59.0 L107.8 107.8 L100.0 100.0 Z" fill="#7fae9f"/><path d="M141.0 59.0 L92.2 92.2 L100.0 100.0 Z" fill="#2B6B5F"/><path d="M141.0 141.0 L92.2 107.8 L100.0 100.0 Z" fill="#7fae9f"/><path d="M141.0 141.0 L107.8 92.2 L100.0 100.0 Z" fill="#2B6B5F"/><path d="M59.0 141.0 L92.2 92.2 L100.0 100.0 Z" fill="#7fae9f"/><path d="M59.0 141.0 L107.8 107.8 L100.0 100.0 Z" fill="#2B6B5F"/><path d="M59.0 59.0 L107.8 92.2 L100.0 100.0 Z" fill="#7fae9f"/><path d="M59.0 59.0 L92.2 107.8 L100.0 100.0 Z" fill="#2B6B5F"/><path d="M100.0 14.0 L115.0 100.0 L100.0 100.0 Z" fill="#5d9a89"/><path d="M100.0 14.0 L85.0 100.0 L100.0 100.0 Z" fill="#1F4E45"/><path d="M186.0 100.0 L100.0 115.0 L100.0 100.0 Z" fill="#5d9a89"/><path d="M186.0 100.0 L100.0 85.0 L100.0 100.0 Z" fill="#1F4E45"/><path d="M100.0 186.0 L85.0 100.0 L100.0 100.0 Z" fill="#5d9a89"/><path d="M100.0 186.0 L115.0 100.0 L100.0 100.0 Z" fill="#1F4E45"/><path d="M14.0 100.0 L100.0 85.0 L100.0 100.0 Z" fill="#5d9a89"/><path d="M14.0 100.0 L100.0 115.0 L100.0 100.0 Z" fill="#1F4E45"/><circle cx="100" cy="100" r="11" fill="#C4451A"/><circle cx="100" cy="100" r="18" fill="none" stroke="#1F4E45" stroke-width="2.5"/></g></svg>';

export const NoteBlock = Node.create({
  name: 'noteBlock',

  group: 'block',

  content: 'block+',

  defining: true,

  addAttributes() {
    return {
      type: {
        default: 'note',
      },
      text: {
        default: '',
      },
      icon: {
        default: '',
      },
      title: {
        default: 'Note',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="note-block"]',
        getAttrs: (element) => {
          return {
            type: element.getAttribute('data-note-type') || 'note',
            icon: element.querySelector('.note-block-icon')?.getAttribute('data-icon') || '',
            title:
              element.querySelector('.note-block-title')?.textContent?.replace(/:\s*$/, '') ||
              'Note',
            text: element.querySelector('.note-block-text')?.textContent || '',
          };
        },
        contentElement: '.note-block-text',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const typeClasses = {
      note: 'note-block--note',
      warning: 'note-block--warning',
      tip: 'note-block--tip',
      disclaimer: 'note-block--disclaimer',
    };
    const typeClass = typeClasses[HTMLAttributes.type] || typeClasses.note;

    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'note-block',
        'data-note-type': HTMLAttributes.type,
        class: `note-block ${typeClass}`,
      }),
      [
        'div',
        { class: 'note-block-header' },
        ['span', { class: 'note-block-icon', 'data-icon': HTMLAttributes.type || 'note' }],
        ['span', { class: 'note-block-title' }, `${HTMLAttributes.title || 'Note'}:`],
      ],
      ['div', { class: 'note-block-text' }, 0],
    ];
  },

  addNodeView() {
    return ({ node, HTMLAttributes, getPos, editor }) => {
      const typeClasses = {
        note: 'note-block--note',
        warning: 'note-block--warning',
        tip: 'note-block--tip',
        disclaimer: 'note-block--disclaimer',
      };
      const typeClass = typeClasses[node.attrs.type] || typeClasses.note;

      // Create main container
      const dom = document.createElement('div');
      dom.setAttribute('data-type', 'note-block');
      dom.setAttribute('data-note-type', node.attrs.type);
      dom.className = `note-block ${typeClass}`;

      // Pastoral notes carry a compass rose behind the text. It is a sibling of
      // contentDOM, never inside it, so ProseMirror never manages or serialises
      // it and the node's content is unaffected.
      if (node.attrs.type === 'pastoral') {
        const wm = document.createElement('div');
        wm.className = 'note-block-wm';
        wm.setAttribute('aria-hidden', 'true');
        wm.innerHTML = PASTORAL_WATERMARK;
        dom.appendChild(wm);
      }

      // Create header
      const header = document.createElement('div');
      header.className = 'note-block-header';

      const icon = document.createElement('span');
      icon.className = 'note-block-icon';
      icon.innerHTML = noteIcon(node.attrs.type);

      const title = document.createElement('span');
      title.className = 'note-block-title';
      title.textContent = `${node.attrs.title || 'Note'}:`;

      header.appendChild(icon);
      header.appendChild(title);
      dom.appendChild(header);

      // Create content container - this is where TipTap will render child content
      const contentDOM = document.createElement('div');
      contentDOM.className = 'note-block-text';

      // If there's legacy text content, show it
      if (node.attrs.text && node.attrs.text.trim()) {
        contentDOM.textContent = node.attrs.text;
      }

      dom.appendChild(contentDOM);

      return {
        dom,
        contentDOM,
      };
    };
  },

  addCommands() {
    return {
      setNoteBlock:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
      updateNoteBlock:
        (attributes) =>
        ({ commands }) => {
          return commands.updateAttributes(this.name, attributes);
        },
    };
  },
});

export default NoteBlock;
